document.addEventListener("DOMContentLoaded", () => {

    const slider = document.querySelector(".ua-category-slider");

    if (!slider) return;

    /* ===============================
       Mouse Wheel Horizontal Scroll
    ================================ */

    slider.addEventListener("wheel", function (e) {

        if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {

            e.preventDefault();

            slider.scrollLeft += e.deltaY;

        }

    }, { passive:false });


    /* ===============================
       Drag Scroll
    ================================ */

    let isDown = false;

    let startX;

    let scrollLeft;

    slider.addEventListener("mousedown",(e)=>{

        isDown=true;

        slider.classList.add("dragging");

        startX=e.pageX-slider.offsetLeft;

        scrollLeft=slider.scrollLeft;

    });

    slider.addEventListener("mouseleave",()=>{

        isDown=false;

        slider.classList.remove("dragging");

    });

    slider.addEventListener("mouseup",()=>{

        isDown=false;

        slider.classList.remove("dragging");

    });

    slider.addEventListener("mousemove",(e)=>{

        if(!isDown) return;

        e.preventDefault();

        const x=e.pageX-slider.offsetLeft;

        const walk=(x-startX)*2;

        slider.scrollLeft=scrollLeft-walk;

    });


    /* ===============================
       Touch Momentum
    ================================ */

    slider.style.scrollBehavior="smooth";


    /* ===============================
       Cursor
    ================================ */

    slider.addEventListener("mouseenter",()=>{

        slider.style.cursor="grab";

    });

    slider.addEventListener("mousedown",()=>{

        slider.style.cursor="grabbing";

    });

    slider.addEventListener("mouseup",()=>{

        slider.style.cursor="grab";

    });


    /* ===============================
       Auto Snap After Drag
    ================================ */

    let snapTimer;

    slider.addEventListener("scroll",()=>{

        clearTimeout(snapTimer);

        snapTimer=setTimeout(()=>{

            const cards=slider.querySelectorAll(".ua-category-card");

            if(!cards.length) return;

            const gap=28;

            const cardWidth=cards[0].offsetWidth+gap;

            const snap=Math.round(slider.scrollLeft/cardWidth);

            slider.scrollTo({

                left:snap*cardWidth,

                behavior:"smooth"

            });

        },120);

    });

});